<template>
    <div class="page">
      <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li>
              <a href="#" class="active">{{ $t("Property") }}</a>
            </li>
            <li>-</li>
            <li>
              <router-link to="/property/allpayment" class="active">{{ $t("orders") }} {{ $t("payment") }} /
                {{ $t("collection") }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <input type="text" :placeholder="$t('number') + ' ' + $t('receipt')" v-model="recnum" />
            {{ $t("from") }}
            <input type="date" :placeholder="$t('date') + ' ' + $t('payment')" v-model="paydatefrom" />
            {{ $t("to") }}
            <input type="date" :placeholder="$t('date') + ' ' + $t('payment')" v-model="paydateto" />
            <input type="text" :placeholder="$t('realty')" v-model="realty" />
            <input type="text" :placeholder="$t('renter')" v-model="renter" />
            <input type="text" :placeholder="$t('contract')" v-model="contract" />
            <button style="padding: 1%" @click="search()">
              {{ $t("search") }}
            </button>
          </div>
          <div class="head2">
            <button>
              <router-link to="/property/createpayment/0/0">+ {{ $t("add") }} {{ $t("payment") }} /
                {{ $t("collection") }}</router-link>
            </button>
          </div>
        </div>
        <div class="body">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t("receipt") }}</th>
                <th>{{ $t("date") }} {{ $t("payment") }}</th>
                <th>{{ $t("realty") }}</th>
                <th>{{ $t("renter") }}</th>
                <th>{{ $t("number") }} {{ $t("contract") }}</th>
                <th>{{ $t("total") }}</th>
                <th>{{ $t("Commissions") }}</th>
                <th>{{ $t("type") }} {{ $t("payment") }}</th>
                <th>{{ $t("description") }}</th>
                <th>{{ $t("status") }}</th>
                <th v-if="hasPermission('property_delete_invoices')">{{ $t("actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in data" :key="val.collid">
                <td>
                  <router-link :to="`/property/paymentview/${val.collid}`" class="active">{{ val.collid }}</router-link>
                </td>
                <td>{{ val.paydate }}</td>
                <td>
                  <router-link :to="`/property/paymentview/${val.collid}`" class="active">{{ val.proname }}</router-link>
                </td>
                <td>{{ val.rentername }}</td>
                <td>{{ val.conid }}</td>
                <td>{{ Number(val.amount).toFixed(2) }}</td>
                <td>{{ Number(Number(val.comtotal) + Number(val.comtax)).toFixed(2) }}</td>
                <td>{{ val.paytype }}</td>
                <td>{{ val.description }}</td>
                <td v-if="val.status == 'waiting'" style="font-weight: bold; background-color: yellow; color: black;">
                  {{ $t(val.status) }}
                </td>
                <td v-if="val.status == 'deported'" style="font-weight: bold; background-color: green; color: white;">
                  {{ $t(val.status) }}
                </td>
                <td v-if="val.status == 'delete'" style="font-weight: bold; background-color: red; color: white;">
                  {{ $t(val.status) }}
                </td>
                <td>
                  <button @click="del(val.collid)" v-if="hasPermission('property_delete_invoices') && val.status !== 'delete'">
                    <i class="bi bi-trash3-fill"></i>
                  </button>
                  <button v-if="val.status == 'waiting'" @click="$router.push(`/property/updatepayment/${val.collid}`)">
                    <i class="bi bi-pencil-fill"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pagination">
            <div class="page-size">
              <label>{{ $t("صف كل صفحة") }}:</label>
              <select v-model="pageSize" @change="changePageSize">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div class="page-nav">
              <button :disabled="currentPage === 1" @click="previousPage">{{ $t("previous") }}</button>
              <span v-for="page in displayedPages" :key="page">
                <button
                  :class="{ active: currentPage === page }"
                  @click="goToPage(page)"
                >{{ page }}</button>
              </span>
              <button :disabled="currentPage === totalPages" @click="nextPage">{{ $t("next") }}</button>
            </div>
            <div class="page-info">
              {{ $t("page") }} {{ currentPage }} {{ $t("of") }} {{ totalPages }} ({{ totalItems }} {{ $t("items") }})
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import axios from "axios";
  import Swal from "sweetalert2";
  import { mapActions } from "vuex";

  export default {
    props: ["css"],
    components: {},
    data() {
      return {
        name: "",
        status: "",
        mobile: "",
        code: "",
        data: [],
        recnum: null,
        paydatefrom: null,
        paydateto: null,
        realty: null,
        renter: null,
        contract: null,
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 1,
      };
    },

    computed: {
      displayedPages() {
        const maxPages = 5;
        const half = Math.floor(maxPages / 2);
        let start = Math.max(1, this.currentPage - half);
        let end = Math.min(this.totalPages, start + maxPages - 1);

        if (end - start + 1 < maxPages) {
          start = Math.max(1, end - maxPages + 1);
        }

        const pages = [];
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
        return pages;
      },
    },

    async mounted() {
      // Initialize from query parameters
      this.recnum = this.$route.query.recnum || null;
      this.paydatefrom = this.$route.query.paydatefrom || null;
      this.paydateto = this.$route.query.paydateto || null;
      this.realty = this.$route.query.realty || null;
      this.renter = this.$route.query.renter || null;
      this.contract = this.$route.query.contract || null;
      this.currentPage = parseInt(this.$route.query.page, 10) || 1;
      this.pageSize = parseInt(this.$route.query.pageSize, 10) || 10;

      await this.fetchData();
    },

    watch: {
      '$route.query': {
        immediate: true,
        handler(newQuery) {
          this.recnum = newQuery.recnum || null;
          this.paydatefrom = newQuery.paydatefrom || null;
          this.paydateto = newQuery.paydateto || null;
          this.realty = newQuery.realty || null;
          this.renter = newQuery.renter || null;
          this.contract = newQuery.contract || null;
          this.currentPage = parseInt(newQuery.page, 10) || 1;
          this.pageSize = parseInt(newQuery.pageSize, 10) || 10;
          this.fetchData();
        },
      },
      name() {
        this.table.rows = this.table.data.filter((x) =>
          x.namear.includes(this.name.toLowerCase())
        );
      },
      status() {
        this.table.rows = this.table.data.filter((x) => x.review == this.status);
      },
    },

    methods: {
      async fetchData() {
        try {
          const response = await axios.post("/reports/allpayments", {
            id: this.recnum || null,
            paydatefrom: this.paydatefrom || null,
            paydateto: this.paydateto || null,
            realty: this.realty || null,
            rentername: this.renter || null,
            conid: this.contract || null,
            page: this.currentPage,
            limit: this.pageSize,
          });
          if (response.status === 200) {
            this.data = response.data.data;
            this.totalItems = response.data.total || 0;
            this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 1;
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          Swal.fire({
            icon: "error",
            title: this.$t("error"),
            text: this.$t("failed_to_load_data"),
          });
        }
      },

      async search() {
        this.currentPage = 1;
        await this.updateQueryParams();
        await this.fetchData();
      },

      async updateQueryParams() {
        const query = {};
        if (this.recnum) query.recnum = this.recnum;
        if (this.paydatefrom) query.paydatefrom = this.paydatefrom;
        if (this.paydateto) query.paydateto = this.paydateto;
        if (this.realty) query.realty = this.realty;
        if (this.renter) query.renter = this.renter;
        if (this.contract) query.contract = this.contract;
        query.page = this.currentPage;
        query.pageSize = this.pageSize;
        await this.$router.push({ query });
      },

      async goToPage(page) {
        if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
          this.currentPage = page;
          await this.updateQueryParams();
          await this.fetchData();
        }
      },

      async previousPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          await this.updateQueryParams();
          await this.fetchData();
        }
      },

      async nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          await this.updateQueryParams();
          await this.fetchData();
        }
      },

      async changePageSize() {
        this.currentPage = 1;
        await this.updateQueryParams();
        await this.fetchData();
      },

      async del(id) {
        Swal.fire({
          title: this.$t("confirm") + "-" + this.$t("delete"),
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            const action = await axios.patch(`/reports/deletepayment/${id}`);
            if (action.status === 200) {
              Swal.fire(this.$t("deleted"));
              await this.fetchData();
            }
          }
        });
      },

      ...mapActions(["redirectTo"]),
    },
  };
  </script>

  <style lang="scss" scoped>
  .page {
    padding: 0.5%;
  }

  .main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 5px;
    border: ridge 0.5px;
  }

  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }

  .head1 {
    width: 90%;
  }

  .head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }

  .head2 {
    width: 30%;
    text-align: center;
  }

  .head2 button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
  }

  .head2 button a {
    color: white;
  }

  .table {
    margin-top: 1%;
  }

  table thead tr {
    border-radius: 5px;
    background-color: #eee;
  }

  button {
    margin: 0.5%;
    padding: 5%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
  }

  .table {
    font-size: x-small;
  }

  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1%;
    padding: 0.5%;
    font-size: small;
  }

  .page-size {
    flex: 1;
  }

  .page-size select {
    margin-left: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }

  .page-nav {
    flex: 2;
    text-align: center;
  }

  .page-nav button {
    margin: 0 0.25%;
    padding: 0.5% 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    cursor: pointer;
  }

  .page-nav button.active {
    background-color: #005566;
    font-weight: bold;
  }

  .page-nav button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .page-info {
    flex: 1;
    text-align: right;
  }
  </style>
